<template>
  <a :href="option.url" v-show="position.show" target="_blank">
    <div v-if="!option.src">
      <a-icon type="picture" class="img-empty" />
    </div>
    <img
      v-else
      :src="option.src"
      :alt="position.title"
      :style="imgStyle"
      :class="option.showOrigin ? 'img-responsive' : 'img'"
    />
  </a>
</template>

<script>
export default {
  // 图片配置项
  name: 'Picture',
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    position: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {
    imgStyle() {
      return {
        opacity: this.option.opacity,
        transform: `rotate(${this.option.rotate}deg)`
      }
    }
  },
  mounted() {},
  created() {},
  methods: {}
}
</script>

<style scoped lang="less">
a {
  width: 100%;
  height: 100%;
  display: block;
  text-decoration: none;
  position: relative;
  overflow: hidden;
}
img {
  width: 100%;
  height: 100%;
}
.img-empty {
  font-size: 80px;
  color: #d9d9d9;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.img-responsive {
  width: auto;
  height: auto;
  max-height: 100%;
  max-width: 100%;
}
</style>
